module.exports = __webpack_public_path__ + "static/media/03.c5707a34.jpg";